<template>
  <div>
    <div class="xsmall-hide small-hide bg-1">
    </div>
    <div class="medium-hide large-hide xlarge-hide">
      <img src="../assets/naniungo-slide-5.jpg">
    </div>
    <div class="md-layout radio" style="min-height:200px;">
      <div class="md-layout-item">
        <md-list>
          <md-subheader>executives - Bereich</md-subheader>

          <md-list-item>
            <md-radio v-model="branch" value="Accounting" />
            <span class="md-list-item-text">Accounting</span>
          </md-list-item>

          <md-list-item>
            <md-radio v-model="branch" value="Controlling" />
            <span class="md-list-item-text">Controlling</span>
          </md-list-item>

          <md-list-item>
            <md-radio v-model="branch" value="Finance"/>
            <span class="md-list-item-text">Finance Functions</span>
          </md-list-item>

          <md-list-item>
            <md-radio v-model="branch" value="Marketing" />
            <span class="md-list-item-text">Marketing</span>
          </md-list-item>
          <md-list-item>
            <md-radio v-model="branch" value="Sonderprojekte" />
            <span class="md-list-item-text">Sonderprojekte</span>
          </md-list-item>
        </md-list>
      </div>
       <div class="md-layout-item center dark" style="margin:20px;">
         <h1 style="margin-top:-6px;" v-if="branch.length !== 0">{{ branch }}</h1>
         <h1 style="margin-top:-6px;" v-else>Bereich wählen</h1>
         <p v-if="branchContains('Accounting')">naniungo unterstützt Sie mit Experten bei Ihren Projekten und Herausforderungen im Accounting, um schnell und flexibel auf Marktveränderungen zu reagieren. Wir verbinden Sie mit genau dem richtigen Experten für unterschiedliche Fragestellungen.</p>
         <p v-if="branchContains('Controlling')">Leicht verständliche Analysen, aussagefähige Kennzahlen und klare Handlungsempfehlungen nehmen wir und unsere Experten gerne für Sie in die Hand, damit Sie sich Ihrem Kerngeschäft widmen können.</p>
         <p v-if="branchContains('Marketing')">Die Zeiten des Gebrauchs traditioneller Kanäle im Bereich der Medien gehört mittlerweile der Vergangenheit an und die Unternehmen, die sich optimal auf diesen Wechsel anpassen und mit modernen Marketingaktivitäten ihre Adressaten zielgerichtet erreichen, werden bekannter und erfolgreicher! Wir helfen Ihnen dabei.</p>
         <p v-if="branchContains('Finance')">In der Kategorie Finance Functions eröffnen wir Ihnen ein Netzwerk an Experten aus dem Bereich Corporate Finance, Treasury, Tax, Audit, Merger & Acquisitions und Risk Management.</p>
         <p v-if="branchContains('Sonderprojekte')">Sie stehen vor großen Veränderungen in Ihrer Organisation? Der Bereich der Sonderprojekte umfasst alle Spezialthemen, bei denen Sie ein ganz bestimmtes Know-how außerhalb der klassischen Finanzbereiche benötigen.</p>
      </div>
    </div>
    <div class="md-layout tab-area md-gutter">
    <div class="cards md-layout-item md-xlarge-size-70 md-large-size-70 md-medium-size-70 md-small-size-100 md-xsmall-size-100" style="background-color:white;">
       <div v-if="branch.length !== 0">
          <div v-for="can in candidates" :key="can">
            <div class="card candidates" v-if="can.functionOne === branch && can.method === 'Executives'">
                <md-card v-bind:class="{ 'md-primary': getCartState(can.ambition) }" md-with-hover>
                  <md-card-header>
                    <md-card-header-text>
                      <p>executives</p>
                      <div class="pull" v-html="can.ambition"></div>
                      <div class="md-subhead">
                        <md-button @click="toggleOpen(can.ambition)" class="md-accent"><md-icon>{{ getToggleState(can.ambition) ? 'remove' : 'add' }}</md-icon>
                          <span style="color:grey;">Profil</span>
                        </md-button>
                        <div v-show-slide:exampleEasing="getToggleState(can.ambition)" v-html="can.hobbies"></div>
                        <div>
                        <span class="hashtag" v-if="can.currentConditions !== null">
                          <button v-for="tag in can.currentConditions.split(',')" :key="tag">{{ tag }}</button>
                        </span>
                        </div>
                      </div>
                    </md-card-header-text>

                    <md-card-media md-big>
                      <span class="level_function">
                        <h2>{{can.level}}</h2>
                        <h3>{{can.functionOne}}</h3>
                      </span>
                    </md-card-media>

                  </md-card-header>
                    <md-card-actions>
                        <span class="chiffre">Kandidaten-Id: {{can.carerix_id}}</span>
                      <md-button @click="toggleCart(can.ambition)" class="md-raised">
                        <span style="text-transform:uppercase; font-size:8px; color:$accent">
                          verfügbarkeit prüfen </span>
                          <md-icon>{{ getCartState(can.ambition) ? 'bookmark' : 'bookmark_border' }}</md-icon>
                        </md-button>
                    </md-card-actions>
                </md-card>
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout-item bg-dark md-xlarge-size-30 md-large-size-30 md-medium-size-30 md-small-size-100 md-xsmall-size-100">
    <div class="container afix-100">
      <div style="margin:20px;">
        <h1>executives</h1>
        <h4>Wie unsere Experten für Personalberatung Ihr Unternehmen vorantreiben</h4>
        <p>Sie suchen Top Spezialisten und Fach- und Führungskräfte für das mittlere oder Top Management? Dann sind Sie bei uns genau richtig. Wir erarbeiten individuelle Strategien und kombinieren verschiedene Marketingaktivitäten, um die besten Kandidaten für Sie zu gewinnen. Wir achten genau darauf, welche Qualifikation und Persönlichkeit in Ihre Organisation passt und nehmen Ihnen voller Leidenschaft den zeitaufwendigen Prozess der Personalsuche ab.</p>
         <router-link @click.native="closeCart()" style="width:100%;" v-bind:to="'projects'">
          <span class="md-list-item-text">
              <h3>Zu den Experten für Ihre Projekte
                <md-icon class="md-list-item-text-after-form">
                  keyboard_arrow_right
                </md-icon>
              </h3>
          </span>
          </router-link>

          <div style="padding-top:20px; border-bottom: 1px solid white;">
            <h2>
              Ansprechpartner
            </h2>
          </div>
        <br>
        <div class="md-layout">
        <div class="md-layout-item md-size-70" style="line-height:90%">
          <md-avatar class="md-large">
            <img src="../assets/nicole.jpg" alt="Avatar">
          </md-avatar>
          <h1>
            Nicole Ziegler
          </h1>
          <md-button style="margin-left:-10px; margin-top:-13px" class="md-accent">
            <md-icon>phone</md-icon><span style="padding-left:15px;">0211 7817 2888</span>
          </md-button>
          <md-button style="margin-left:-10px; margin-top:-13px" class="md-accent">
            <md-icon>access_time</md-icon><span style="padding-left:15px;">Mo-Fr: 8:00-19:00 Uhr</span>
          </md-button>
       </div>  
        <div class="md-layout-item md-size-30">
      </div>  
    </div>
    <div style="padding-top:10px; border-bottom: 1px solid white;">
      <h2>
        Artikel
      </h2>
    </div>
    <br>
    <router-link style="width:100%;" v-bind:to="'/article/changemanagement'" exact>
      <span class="md-list-item-text">
          <h3>mehr zu Changemanagement
            <md-icon class="md-list-item-text-after-form">
              keyboard_arrow_right
            </md-icon>
          </h3>
      </span>
    </router-link>
    <router-link style="width:100%;" v-bind:to="'/article/personalberatung'">
      <span class="md-list-item-text">
          <h3>mehr zu Personalberatung
            <md-icon class="md-list-item-text-after-form">
              keyboard_arrow_right
            </md-icon>
          </h3>
      </span>
    </router-link>
    </div>
    </div>
    </div>
      </div>
    <div class="message dark secondary mt-40">
      <router-link style="width:100%;"
                   v-bind:to="'/representatives'" exact>
        <h1>representatives<md-icon class="green ml-20">arrow_forward</md-icon>
        </h1>
      </router-link>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Candidates",
  data() {
    return {
      firstName: "",
      lastName: "",
      jobTitle: "",
      emailAddressPrivate: "",
      phoneNumberBusiness: "",
      hobbies: "",
      ambition: "",
      level: "",
      function: "",
      carerix_id: "",
      functionOne: "",
      loadingBar: true,
      method: "",
      xsmall: false,
      small: false,
      medium: false,
      large: false,
      xlarge: false,
      varCandidates: [],
      branch:[],
      a: 0,
      b: 0,
      c: 0
    };
  },
  computed: {
    ...mapState({
      candidates: state => state.candidates.candidates,
      cart: state => state.cart.cart
    })
  },
  created() {
    // this.$store.dispatch('candidates/getCandidates');
    // this.handleResize();
    // window.addEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions("candidates", "cart", [
      "addCandidate",
      "deleteCandidate",
      "updateCandidate",
      "getCart"
    ]),
    branchContains(n) {
      return this.branch.indexOf(n) > -1
    },
    toggleOpen(value) {
      var item = this.varCandidates.filter(obj => {
        return obj.ambition === value;
      })[0];

      if (typeof item !== "undefined") {
        item.isOpen = !item.isOpen;
      }
    },
    getToggleState(value) {
      const item = this.varCandidates.filter(obj => {
        return obj.ambition === value;
      })[0];
      if (typeof item !== "undefined") {
        return item.isOpen;
      }
    },
    toggleCart(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter(obj => {
        return obj.ambition === value;
      })[0];
      if (typeof item !== "undefined") {
        item.addtoCart = !item.addtoCart;
      }
    },
    getCartState(value) {
      // const item = this.$store.state.cart.cart.filter(obj => {
      // const item = this.varCandidates.filter(obj => {
      const item = this.$store.state.cart.cart.filter(obj => {
        return obj.ambition === value;
      })[0];
      if (typeof item !== "undefined") {
        return item.addtoCart;
      }
    }
  },
  mounted() {
    // if (localStorage.getItem('varCandidates') === 'true' && localStorage.getItem('varCandidates').length ==  this.$store.state.candidates.candidates.length) {
    if (localStorage.getItem("varCandidates")) {
      this.varCandidates = JSON.parse(localStorage.getItem("varCandidates"));

      this.a = this.$store.state.candidates.candidates.length;
      this.b = JSON.parse(
        localStorage.getItem("store")
      ).candidates.candidates.length;
      this.c = JSON.parse(localStorage.getItem("varCandidates")).length;
      if (this.b !== this.c) {
        this.varCandidates = [];
        for (var ii in this.$store.state.candidates.candidates) {
          var item1 = this.$store.state.candidates.candidates[ii];
          this.varCandidates.push({
            ambition: item1.ambition,
            isOpen: false,
            addtoCart: false,
            carerix_id: item1.carerix_id
          });
        }
      }
    } else {
      for (var i in this.$store.state.candidates.candidates) {
        var item = this.$store.state.candidates.candidates[i];
        this.varCandidates.push({
          ambition: item.ambition,
          isOpen: false,
          addtoCart: false,
          carerix_id: item.carerix_id
        });
      }
    }
    // if (this.window.width < 600) {
    //   this.xsmall = true;
    // }
  },
  watch: {
    varCandidates: {
      handler() {
        localStorage.setItem(
          "varCandidates",
          JSON.stringify(this.varCandidates)
        );
        this.$store.dispatch("cart/getCart");
      },
      deep: true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/shared.scss";
.bg-1 {
  background: url("../assets/naniungo-slide-5.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 500px;
  background-position: right 0px top 44px !important;
}

.profiles {
  margin-left: 10px;
  margin-right: 10px;

  .md-card-header {
    padding: 16px;
  }

  .md-card {
    margin: 10px;
    width: 55vw;
    display: inline-block;
    vertical-align: top;
  }

  // @media (min-width: 300px) and (max-width: 1300px) {
  //   .md-card {
  //     width:48vw;
  //     }
  // }
  @media (min-width: 100px) and (max-width: 600px) {
    .md-card {
      min-width: 80vw !important;
    }
  }
  @media (min-width: 1100px) and (max-width: 1400px) {
    .md-card {
      width: 50vw !important;
    }
  }
  @media (min-width: 950px) and (max-width: 1400px) {
    .md-card {
      width: 47vw !important;
    }
  }

  .md-title {
    // margin-right:80px !important;
    h3 {
      font-size: 30px !important;
      margin-top: -2px;
      font-weight: 900;
    }
  }
  .md-subhead {
    // margin-right:80px !important;
    p {
      font-size: 16px !important;
      color: white;
    }
  }
  .md-card-actions {
    margin-bottom: 5px;
    margin-right: 5px;
  }
}
</style>
